<template>
    <auth-card-template :large="!isRegistered">
        <card-auth v-if="!isRegistered">
            <div class="text-center mb-6">
                <h4 class="font-family-title font-weight-bold text-success mb-4">Cadastre-se com suas redes socias!</h4>
                <nav-social />
            </div>

            <div class="text-center mb-4">
                Ou utilize seu endereço de e-mail:
            </div>

            <div v-show="errorMessage" class="alert alert-danger mb-6" v-html="errorMessage"></div>

            <form @submit.prevent="$_recaptcha_verify(register)">
                <form-group label="E-mail" label-for="registerEmail" :error="formErrors.email">
                    <input type="email" id="registerEmail" class="form-control" autocomplete="email" spellcheck="false" autofocus v-model="formData.email" v-input-lowercase>
                </form-group>

                <form-group label="Senha" label-for="registerPassword" :error="formErrors.password">
                    <input type="password" id="registerPassword" class="form-control" maxlength="100" autocomplete="new-password" v-model="formData.password">
                    <popover-password target="registerPassword" minlength="8" hasletter hasnumber v-model="formData.password" />
                </form-group>

                <form-group label="Confirme sua senha" label-for="registerPasswordConfirm" :error="formErrors.passwordConfirm">
                    <input type="password" id="registerPasswordConfirm" class="form-control" maxlength="100" autocomplete="new-password" v-model="formData.passwordConfirm">
                </form-group>

                <form-group label="Nome completo" label-for="registerName" :error="formErrors.name">
                    <input type="text" id="registerName" class="form-control" autocomplete="name" v-model="formData.name">
                </form-group>

                <div class="mt-6">
                    <p class="text-muted text-center mb-6">
                        Ao clicar em Cadastrar, você confirma que leu e aceitou nossos<br>
                        <a href="https://hostoo.io/legal/termos" target="_blank">Termos de Uso</a> e
                        <a href="https://hostoo.io/legal/politica-de-privacidade" target="_blank">Política de Privacidade</a>.
                    </p>
                    <button-form ref="btnRegister" type="submit" theme="success" class="btn-lg btn-block">Cadastrar</button-form>
                </div>
            </form>

            <div class="text-center mt-6">
                Já possui uma conta?<br>
                <router-link to="/auth/login" class="text-lg font-weight-semibold">Acesse agora!</router-link>
            </div>

            <vue-recaptcha
                v-if="recaptchaKey"
                ref="recaptcha"
                size="invisible"
                :sitekey="recaptchaKey"
                :loadRecaptchaScript="true"
                @verify="$_recaptcha_onVerified"
                @expired="$_recaptcha_onExpired" />
        </card-auth>

        <card-auth v-else>
            <h4 class="font-family-title font-weight-bold text-success text-center mb-6">Obrigado por se cadastrar!</h4>

            <div class="text-center">
                <p class="text-lg">
                    <span class="d-inline-block mb-3">Agora, confirme o e-mail clicando no link enviado para</span><br>
                    <span class="font-weight-semibold">{{ registeredEmail }}</span>
                </p>

                <p class="text-muted mb-6">
                    Caso o e-mail não esteja em sua caixa de entrada, verifique em sua pasta de spam ou lixo eletrônico.
                    Se não receber o e-mail em até 5 minutos, informe o problema ao nosso suporte.
                </p>

                <router-link :to="{ path: '/auth/login', query: { email: registeredEmail }}" class="text-lg font-weight-semibold">Fazer login</router-link>
            </div>
        </card-auth>
    </auth-card-template>
</template>

<script>
    import VueRecaptcha     from 'vue-recaptcha'
    import recaptcha        from '@/mixins/recaptcha'
    import ErrorService     from '@/services/error.service'
    import ButtonForm       from '@/components/atoms/ButtonForm'
    import PopoverPassword  from '@/components/atoms/PopoverPassword'
    import NavSocial        from '@/components/molecules/NavSocial'
    import FormGroup        from '@/components/molecules/FormGroup'
    import CardAuth         from '@/components/organisms/CardAuth'
    import AuthCardTemplate from '@/components/templates/AuthCardTemplate'

    export default {
        mixins: [recaptcha],
        components: {
            PopoverPassword,
            ButtonForm,
            VueRecaptcha,
            FormGroup,
            CardAuth,
            NavSocial,
            AuthCardTemplate
        },
        data() {
            return {
                formData: {},
                formErrors: {},
                errorMessage: "",
                isRegistered: false,
                registeredEmail: "teste@teste.com.br",
                recaptchaKey: "",
            }
        },
        created()
        {
            // reCAPTCHA
            this.recaptchaKey = process.env.VUE_APP_RECAPTCHA_SITE_KEY;

            // Tag de conversão do Facebook
            if (typeof window.fbq !== 'undefined') {
                fbq('trackCustom', 'PG-Registro');
            }

            // Pegar e-mail pela URL e inserir no campo de e-mail
            if (this.$route.query.email) {
                this.$set(this.formData, 'email', this.$route.query.email);
            }

            // Pegar nome do usuário pela URL e inserir no campo de nome
            if (this.$route.query.name) {
                this.$set(this.formData, 'name', this.$route.query.name);
            }

            // Salvar código promocional nos cookies
            if (this.$route.query.c) {
                this.$cookie.set('hos_code', this.$route.query.c, 7);
            }

            // Domínio para registro
            if (this.$route.query.domain && /^([a-zA-Z0-9\-]+\.)*[a-zA-Z0-9][a-zA-Z0-9\-]+\.[a-zA-Z]{2,13}?$/.test(String(this.$route.query.domain))) {
                this.$cookie.set('hos_domain', this.$route.query.domain, { expires: '15m' });
            }
        },
        methods: {
            /**
             * Realizar cadastro do usuário.
             */
            register()
            {
                this.formErrors = {};
                this.errorMessage = "";

                this.$refs.btnRegister.loadingFocus();

                let postData = Object.assign({ captcha: this.$_recaptcha_token }, this.formData);

                const promotionalCode = this.$cookie.get("hos_code");      // Cupom promocional
                const referralCode    = this.$cookie.get("hos_affiliate"); // Código de afiliado/indicação
                const domain          = this.$cookie.get("hos_domain");    // Domínio para registro

                if (promotionalCode) {
                    postData.code = promotionalCode;
                }

                if (referralCode) {
                    postData.referral = referralCode;
                }

                if (domain) {
                    postData.domain = domain;
                }

                this.$api.post('/register', postData)
                    .then(response => {
                        this.registeredEmail = response.data.data.email;
                        this.isRegistered    = true;

                        // Tag de conversão do Facebook
                        if (typeof window.fbq !== 'undefined')
                        {
                            fbq('trackCustom', 'Lead-Hostoo');
                            fbq('track', 'Lead');
                        }

                        // Tag de conversão do Google Ads
                        if (typeof window.gtag !== 'undefined') {
                            gtag('event', 'conversion', {'send_to': 'AW-798302531/LbSyCIjIgcQBEMPC1PwC'});
                        }

                        // Tag do GA4
                        if (typeof window.gtag !== 'undefined' && typeof window.GA4_MEASUREMENT_ID !== 'undefined')
                        {
                            gtag('event', 'form_inicio', {
                                'send_to': window.GA4_MEASUREMENT_ID,
                                'method': 'Email',
                            });
                        }
                    })
                    .catch(error => {
                        const status = error.response.status || 0;

                        if (status === 422) {
                            ErrorService.handleFormError(error, this);
                        }
                        else if (status >= 400 && typeof error.response.data.message !== 'undefined') {
                            this.errorMessage = error.response.data.message;
                        }
                        else {
                            this.showErrorAlert(error);
                        }

                        this.$refs.btnRegister.setLoading(false);
                        this.$refs.recaptcha.reset();
                    });
            }
        }
    }
</script>